import { render, staticRenderFns } from "./contract-view.vue?vue&type=template&id=519ced2c"
import script from "./contract-view.vue?vue&type=script&lang=js"
export * from "./contract-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports